import React, { useState } from "react";
import {
  Plus,
  Edit,
  Trash,
  Search,
  Boxes,
  Cpu,
  HardDrive,
  MemoryStick,
  MonitorCog,
  Disc,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import "./Custompc.css";

export default function CustomPC() {
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "stock", direction: "asc" });
  const [components, setComponents] = useState([
    { id: 1, name: "Cabinet", stock: 12, status: "Active", icon: "Boxes" },
    { id: 2, name: "CPU", stock: 5, status: "Active", icon: "Cpu" },
    { id: 3, name: "Motherboard", stock: 7, status: "Inactive", icon: "MonitorCog" },
    { id: 4, name: "SSD", stock: 20, status: "Active", icon: "HardDrive" },
    { id: 5, name: "RAM", stock: 18, status: "Active", icon: "MemoryStick" },
    { id: 6, name: "GPU", stock: 3, status: "Inactive", icon: "MonitorCog" },
    { id: 7, name: "OS", stock: 50, status: "Active", icon: "Disc" },
  ]);

  const iconMap = {
    Boxes: <Boxes size={20} />,
    Cpu: <Cpu size={20} />,
    HardDrive: <HardDrive size={20} />,
    MemoryStick: <MemoryStick size={20} />,
    MonitorCog: <MonitorCog size={20} />,
    Disc: <Disc size={20} />,
  };

  const [editModal, setEditModal] = useState({ open: false, component: null });
  const [editStock, setEditStock] = useState("");
  const [editStatus, setEditStatus] = useState("Active");

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key, direction });
  };

  const sortedComponents = [...components].sort((a, b) => {
    if (!sortConfig.key) return 0;
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];
    if (sortConfig.key === "status") {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }
    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const filtered = sortedComponents.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  const SortIcons = ({ columnKey }) => {
    const isActive = sortConfig.key === columnKey;
    return (
      <span
        className="adcustompc-sort-icons"
        style={{ display: "inline-flex", flexDirection: "column", marginLeft: 5 }}
      >
        <ChevronUp size={12} color={isActive && sortConfig.direction === "asc" ? "#568ddf" : "#ccc"} />
        <ChevronDown size={12} color={isActive && sortConfig.direction === "desc" ? "#568ddf" : "#ccc"} />
      </span>
    );
  };

  const openEditModal = (component) => {
    setEditModal({ open: true, component });
    setEditStock(component.stock);
    setEditStatus(component.status);
  };

  const closeModal = () => setEditModal({ open: false, component: null });

  const handleSubmit = () => {
    const updatedComponents = components.map((c) =>
      c.id === editModal.component.id ? { ...c, stock: editStock, status: editStatus } : c
    );
    setComponents(updatedComponents);
    closeModal();
  };

  return (
    <div className="adcustompc-custompc-container">
      <h2 className="adcustompc-title">Custom PC Components</h2>

      <div className="adcustompc-top-bar">
        <div className="adcustompc-search-box">
          <Search size={20} />
          <input
            type="text"
            placeholder="Search component..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="adcustompc-table-container">
        <table className="adcustompc-component-table">
          <thead>
            <tr>
              <th>Component</th>
              <th onClick={() => handleSort("stock")} style={{ cursor: "pointer" }}>
                Stock <SortIcons columnKey="stock" />
              </th>
              <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                Status <SortIcons columnKey="status" />
              </th>
              <th style={{ textAlign: "right" }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((c) => (
              <tr key={c.id}>
                <td className="adcustompc-comp-cell">
                  <span className="adcustompc-table-icon">{iconMap[c.icon]}</span>
                  <span>{c.name}</span>
                </td>
                <td>{c.stock}</td>
                <td>
                  <span className={c.status === "Active" ? "adcustompc-active" : "adcustompc-inactive"}>
                    {c.status}
                  </span>
                </td>
                <td className="adcustompc-actions-cell">
                  <Edit size={18} className="adcustompc-edit" onClick={() => openEditModal(c)} />
                  <Trash size={18} className="adcustompc-delete" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editModal.open && (
        <div className="adcustompc-modal-overlay">
          <div className="adcustompc-modal">
            <h3>Edit Component: {editModal.component.name}</h3>
            <div className="adcustompc-modal-content">
              <label>
                Component Name:
                <input type="text" value={editModal.component.name} disabled />
              </label>
              <label>
                Stock:
                <input
                  type="number"
                  value={editStock}
                  onChange={(e) => setEditStock(Number(e.target.value))}
                />
              </label>
              <label>
                Status:
                <select value={editStatus} onChange={(e) => setEditStatus(e.target.value)}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </label>
            </div>
            <div className="adcustompc-modal-actions">
              <button className="adcustompc-cancel-btn" onClick={closeModal}>
                Cancel
              </button>
              <button className="adcustompc-submit-btn" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}